/** @enum string */
const MessageType = Object.freeze({
  /** @type {'success'} */ SUCCESS: 'success',
  /** @type {'warning'} */ WARNING: 'warning',
  /** @type {'error'} */ ERROR: 'error',
  /** @type {'info'} */ INFO: 'info',
})
export default MessageType
